export default {
  industrial: 'industrial',
  civil: 'civil',
  infrastructure: 'infrastructure'
};
